import type { FAQContent } from '../schema';

export const faqs = [] satisfies readonly FAQContent[];
